<template>
  <div class="card">
    <loading :active.sync="loading" can-cancel="true" :is-full-page="true" />
    <div class="card-header">
      <button class="btn btn-secondary float-right" @click.prevent="reload">
        <i class="fas fa-sync-alt"></i> Limpar Consultas
      </button>
    </div>
    <div class="card-body">
      <div
        class="modal fade"
        id="staticBackdrop"
        data-backdrop="static"
        data-keyboard="false"
        tabindex="-1"
        role="dialog"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="staticBackdropLabel">Whois</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <pre>
                {{ asnData }}
              </pre>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-md-8">
          <ul class="nav">
            <li class="nav-item">
              <!-- <a class="nav-link" href="http://131.100.106.82/downloads/100M"
                >100M <i class="fas fa-cloud-download-alt"></i
              ></a> -->

              <a class="nav-link" href="http://177.85.176.242/downloads/100M"
                >100M <i class="fas fa-cloud-download-alt"></i
              ></a>
            </li>
            <li class="nav-item">
              <!-- <a class="nav-link" href="http://131.100.106.82/downloads/250M"
                >250M <i class="fas fa-cloud-download-alt"></i
              ></a> -->

              <a class="nav-link" href="http://177.85.176.242/downloads/250M"
                >250M <i class="fas fa-cloud-download-alt"></i
              ></a>
            </li>
            <li class="nav-item">
              <!-- <a class="nav-link" href="http://131.100.106.82/downloads/500M"
                >500M <i class="fas fa-cloud-download-alt"></i
              ></a> -->

              <a class="nav-link" href="http://177.85.176.242/downloads/500M"
                >500M <i class="fas fa-cloud-download-alt"></i
              ></a>
            </li>
            <li class="nav-item">
              <!-- <a class="nav-link" href="http://131.100.106.82/downloads/1024M"
                >1024M <i class="fas fa-cloud-download-alt"></i
              ></a> -->

              <a class="nav-link" href="http://177.85.176.242/downloads/1024M"
                >1024M <i class="fas fa-cloud-download-alt"></i
              ></a>
            </li>
          </ul>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col-md-4">
          <label>Route Server</label>
          <select class="form-control form-control-md" v-model="routers">
            <option value="router1">FRRouting</option>
            <!-- <option value="router2">Dominet-RVD - Juniper</option> -->
            <!-- <option value="router3">Bemar - Huawei</option> -->
            <option value="router4">AT&T - New York(EUA) | Juniper</option>
            <option value="router5">IX.SP | Quagga</option>
          </select>
        </div>

        <div class="form-group col-md-2">
          <label>Comando</label>
          <select class="form-control form-control-md" v-model="query">
            <template v-if="routers == 'router1'">
              <option value="bgp">Show route</option>
              <option value="mtr">MTR - beta</option>
              <option value="as-path-regex">Show route as-path-regex</option>
              <option value="as">Show route AS</option>
              <option value="ping">Ping </option>
              <option value="traceroute">Traceroute</option>
              <option value="tcptraceroute">TCP Traceroute</option>
            </template>

            <template v-if="routers == 'router4'">
              <option value="bgp">Show route</option>
              <option value="bgp_detail">Show route Detail</option>
            </template>

            <template v-if="routers == 'router5'">
              <option value="bgp">Show route</option>
              <!-- <option value="bgp_detail">Show route Detail</option> -->
            </template>
          </select>
        </div>

        <div class="form-group col-md-6">
          <label>Parametro</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control form-control-md"
              placeholder="IP, IPv6, AS, Domínio"
              @keyup.enter="send"
              v-model="parameter"
            />
            <span class="input-group-append">
              <button
                class="btn btn-primary"
                @click="send"
                @keydown.enter="send"
              >
                <i class="fas fa-search"></i> Consultar
              </button>
            </span>
            <span class="input-group-append">
              <a
                :href="`https://bgp.he.net/ip/${parameter}`"
                class="btn btn-danger"
                target="_blank"
              >
                <i class="fas fa-external-link-square-alt"></i> bgp.he.net
              </a>
            </span>
            <span class="input-group-append">
              <button
                class="btn btn-primary"
                @click="whoisIP(parameter)"
                @keydown.enter="whoisIP(parameter)"
              >
                <i class="fas fa-search"></i> Whois
              </button>
            </span>
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col-md-8 bm-3"></div>
        <div class="form-group col-md-4 bm-3">
          <div class="input-group">
            <input
              type="text"
              class="form-control form-control-md"
              placeholder="Consultar asn..."
              v-model="currentAsn"
              @keyup.enter="whoisResume(currentAsn)"
            />
            <span class="input-group-append">
              <button class="btn btn-primary" @click="whoisResume(currentAsn)">
                <i class="fas fa-search"></i> Consultar asn
              </button>
            </span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-7">
          <b-tabs content-class="mt-2">
            <b-tab
              v-for="result in results"
              :key="result.ip"
              :title="result.ip"
              :active="result.ip == currentIp"
              @click="clickTab($event)"
            >
              <div class="card">
                <div class="card-body">
                  <div v-html="result.data" :id="result.ip"></div>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
        <div class="col-md-5">
          <b-tabs content-class="mt-2">
            <b-tab
              v-for="result in resumeAsnData"
              :key="result.asn"
              :title="result.asn"
              :active="result.asn == currentAsn"
              @click="clickTabAS($event)"
            >
              <div class="card">
                <div class="card-body">
                  <pre>
                    {{ result.data }}
                  </pre>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "vue-loading-overlay";
import { isEmpty } from "lodash";
import $ from "jquery";

export default {
  components: {
    Loading
  },
  data() {
    return {
      loading: false,
      routers: "router1",
      parameter: null,
      query: "bgp",
      results: [],
      currentIp: null,
      currentAsn: null,
      resumeAsnData: [],
      asnData: null
    };
  },

  methods: {
    clickTabAS(e) {
      this.currentAsn = e.target.innerHTML;
    },
    clickTab(e) {
      this.parameter = e.target.innerHTML;
    },
    send() {
      const fd = new FormData();
      fd.append("routers", this.routers);
      fd.append("parameter", this.parameter);
      fd.append("query", this.query);
      fd.append("dontlook", "");

      this.loading = true;

      axios.post(process.env.VUE_APP_FRR_URL, fd).then(res => {
        let result = {
          ip: null,
          data: {}
        };

        this.currentIp = this.parameter;
        result.ip = this.parameter;
        result.data = res.data.result;
        result.asnList = [];

        const index = this.results.findIndex(item => item.ip == result.ip);
        if (index !== -1) {
          this.results.splice(index, 1, result);
        } else {
          this.results.push(result);
        }

        this.loading = false;
      });
    },
    reload() {
      this.results = [];
      this.currentIp = null;
      this.parameter = null;
      this.currentAsn = null;
      this.resumeAsnData = [];
      this.asnData = null;
    },
    setCurrentAsn() {
      this.currentAsn = window.getSelection().toString();
    },
    getSelectedText() {
      // const ip = window.getSelection().baseNode.parentElement.parentElement.id;
      const param = window.getSelection().toString();

      if (this.results.length) {
        if (!isEmpty(param)) {
          this.searchBgpView(param);
        }
      }
    },
    searchBgpView(param) {
      this.currentAsn = param;
      this.loading = true;

      const url = "131.100.106.82";

      // const url = '170.81.93.101';

      axios
        .get(`http://${url}/whois/`, {
          params: { param: "AS" + param }
        })
        .then(res => {
          this.asnData = res.data.data;

          $("#staticBackdrop").modal({ backdrop: true, keyboard: true });

          this.loading = false;
        });
    },
    whoisIP() {
      this.loading = true;
      axios
        .get("http://whois.l7.net.br/", {
          params: { param: this.parameter }
        })
        .then(res => {
          this.asnData = res.data.data;

          $("#staticBackdrop").modal({ backdrop: true, keyboard: true });

          this.loading = false;
        });
    },
    whoisResume() {
      this.loading = true;
      axios
        .get("http://whois.l7.net.br/", {
          params: { param: this.currentAsn, resume: true }
        })
        .then(res => {
          let data = {};
          data.asn = this.currentAsn;
          data.data = res.data.data;

          const index = this.resumeAsnData.findIndex(
            item => item.asn == data.asn
          );
          if (index !== -1) {
            this.resumeAsnData.splice(index, 1, data);
          } else {
            this.resumeAsnData.push(data);
          }

          this.loading = false;
        });
    }
    // searchBgpView(param, ip) {
    //   this.currentAsn = param;
    //   this.loading = true;
    //   axios.get(`https://api.bgpview.io/asn/${param}`).then((res) => {

    //     let asnData = {
    //       asn: res.data.data.asn,
    //       name: res.data.data.name
    //     };

    //     this.results.map((item) => {
    //       if (item.ip == ip) {
    //         const index = item.asnList.findIndex(item => item.asn == asnData.asn);
    //         if (index !== -1) {
    //           item.asnList.splice(index, 1, asnData);
    //         } else {
    //           item.asnList.push(asnData);
    //         }
    //       }
    //     });

    //     this.loading = false;
    //   })
    // }
  }
};
</script>
